import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const employeeTransactionAccessService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/AccessTemplate/employee-transaction-access`, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/AccessTemplate/employee-transaction-access/${id}`, payload, { headers });
  },
};

export default employeeTransactionAccessService;